import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Box, LinearProgress } from '@mui/material'
import { CRM_POLL, crmApi } from '../../../features/crm/crmApi'
import { Card, Muted, PageHead, Pill, TableWrap, contentSx, pageSx } from '../shared/crmUi'
import { fmtDate, formatPhone, hm } from '../shared/format'
import { mentorColumn } from '../shared/stages'
import { EmptyRow } from '../head/HeadCrmNewPage'
import { GroupTag, MentorStrip } from './MentorTasksPage'

const TONE = { todo: 'grey', doing: 'wait', done: 'ok' } as const

const MentorStudentsPage = () => {
    const { formatMessage } = useIntl()
    const { data = [], isFetching } = crmApi.useGetMentorTracksQuery(undefined, { pollingInterval: CRM_POLL })
    const rows = useMemo(() => [...data].sort((a, b) => ((a.assignedAt || '') < (b.assignedAt || '') ? 1 : -1)), [data])
    const multiGroup = new Set(data.map((t) => t.groupTitle)).size > 1

    return (
        <Box sx={pageSx}>
            <Box sx={contentSx}>
                <PageHead title={formatMessage({ id: 'crmMyMentorStudents' })} sub={formatMessage({ id: 'crmMyMentorStudentsSub' })} />
                {isFetching && !data.length && <LinearProgress sx={{ marginBottom: 1 }} />}
                <MentorStrip tracks={data} />
                <Card pad={false}>
                    <TableWrap minWidth={620}>
                        <table>
                            <thead>
                                <tr>
                                    <th>{formatMessage({ id: 'crmColStudent' })}</th>
                                    <th>{formatMessage({ id: 'crmParent' })}</th>
                                    <th>{formatMessage({ id: 'crmAssignedCol' })}</th>
                                    <th>{formatMessage({ id: 'crmColStage' })}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((t) => {
                                    const col = mentorColumn(t)
                                    return (
                                        <tr key={t.id}>
                                            <td>
                                                <b>{t.studentName}</b> {multiGroup && <GroupTag title={t.groupTitle} />}
                                                <Muted>{formatPhone(t.studentPhone)}</Muted>
                                            </td>
                                            <td>
                                                {t.parentName}
                                                <Muted>{formatPhone(t.parentPhone)}</Muted>
                                            </td>
                                            <td className="num" style={{ textAlign: 'left' }}>
                                                {fmtDate(t.assignedAt)}
                                                <Muted>{hm(t.assignedAt)}</Muted>
                                            </td>
                                            <td>
                                                <Pill tone={TONE[col]}>{formatMessage({ id: col === 'done' ? 'crmFinishedCheck' : `crmCol_${col}` })}</Pill>
                                            </td>
                                        </tr>
                                    )
                                })}
                                {!rows.length && <EmptyRow cols={4} text={formatMessage({ id: 'crmNoStudents' })} />}
                            </tbody>
                        </table>
                    </TableWrap>
                </Card>
            </Box>
        </Box>
    )
}

export default MentorStudentsPage
